
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#0B1F3B] to-[#0d2847] text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Bastian Digital Service
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Semua Layanan Digital & Servis Ada di Sini
            </p>
            <div className="flex gap-4">
              <a
                href="https://wa.me/6285868360910"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-[#25D366] hover:bg-[#20bd5a] rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FF8A00]">Layanan Cepat</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-gray-300 hover:text-[#FF8A00] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line"></i>
                  Foto & Cetak
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-[#FF8A00] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line"></i>
                  Desain & Percetakan
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-[#FF8A00] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line"></i>
                  Servis Laptop & HP
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-[#FF8A00] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line"></i>
                  CCTV & LED
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FF8A00]">Kontak</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-300">
                <i className="ri-map-pin-line text-xl text-[#FF8A00] mt-1 flex-shrink-0"></i>
                <span className="text-sm">
                  Banjiran Gg. 8 No.12<br />
                  Warungasem – Batang<br />
                  Jawa Tengah, Indonesia
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-300">
                <i className="ri-whatsapp-line text-xl text-[#FF8A00] flex-shrink-0"></i>
                <a href="https://wa.me/6285868360910" className="text-sm hover:text-[#FF8A00] transition-colors cursor-pointer">
                  0858-6836-0910
                </a>
              </li>
            </ul>
          </div>

          {/* Operating Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FF8A00]">Jam Operasional</h4>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li className="flex justify-between">
                <span>Senin - Sabtu</span>
                <span className="font-semibold">08:00 - 20:00</span>
              </li>
              <li className="flex justify-between">
                <span>Minggu</span>
                <span className="font-semibold">09:00 - 17:00</span>
              </li>
            </ul>
            <div className="mt-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-4">
              <p className="text-xs text-gray-300">
                <i className="ri-information-line text-[#FF8A00]"></i> Order online via WhatsApp 24/7
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Bastian Digital Service. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#FF8A00] text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
